// src/hooks/useScrollToTop.js

import { useCallback } from 'react';

export default function useScrollToTop() {
  return useCallback(() => {
    const el = document.querySelector('.app-content');
    if (el) {
      el.scrollTo({ top: 0, behavior: 'smooth' });
    } else {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  }, []);
}
